// NPM Imports
import React, { Component } from "react";
import PropTypes from "prop-types";
import { Label, Input } from "@revvsales/components";

// Components Imports

class CheckBoxEditor extends Component {
  state = {
    value: this.props.value,
  };

  // ag-grid needs this function to set the value for the cell
  getValue() {
    return this.state.value;
  }

  _onCheckChange = () => {
    this.setState(prevState => ({ value: !prevState.value }));
  };

  render() {
    return (
      <Label htmlFor="grid-checkbox-editor">
        <Input
          id="grid-checkbox-editor"
          type="checkbox"
          value=""
          checked={this.state.value}
          onChange={() => this._onCheckChange()}
          data-test="checkboxeditor-input"
        />
      </Label>
    );
  }
}

CheckBoxEditor.defaultProps = {
  value: false,
};

CheckBoxEditor.propTypes = {
  // Props
  value: PropTypes.bool,
};
export default CheckBoxEditor;



// WEBPACK FOOTER //
// ./src/components/AgGridCellEditor/CheckBoxEditor.js